import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_IP,
  // baseURL: "http://localhost:5000/api/v1/",
  withCredentials: true,
  credentials: "include",
  headers: {
    headers: { "Content-Type": "application/json" },
    Accept: "application/json",
  },
});

api.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    let originalRequest = error.config;
    if (
      error.response.status === 401 &&
      originalRequest &&
      !originalRequest._isRetry
    ) {
      originalRequest._isRetry = true;
      try {
        const refreshApi = axios.create({
          baseURL: process.env.REACT_APP_IP,
          // baseURL: "http://localhost:5000/api/v1/",
          withCredentials: true, // Set withCredentials here
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        const response = await refreshApi.post("auth/refresh");

        return api.request(originalRequest);
      } catch (err) {
        console.log(err.message);
      }
    }
    throw error;
  },
);

export default api;
